import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=071d3c66&scoped=true&"
import script from "./Timer.vue?vue&type=script&lang=js&"
export * from "./Timer.vue?vue&type=script&lang=js&"
import style0 from "./Timer.vue?vue&type=style&index=0&id=071d3c66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d3c66",
  null
  
)

export default component.exports